import { formatLocation } from "kinnect-formatters";
import {
	Model,
	User
} from ".";

export default class SalesLead extends Model {
	get singularNoun() {
		return "sales lead";
	}

	get mutations() {
		return {
			userCreatedBy: User
		};
	}

	get createdTimestamp() {
		return ( new Date( this.created_at ) ).getTime();
	}

	get completed() {
		return this.$.status === "Completed";
	}

	get projectFullAddress() {
		if ( this.projectAddress ) {
			return formatLocation( {
				address: this.projectAddress,
				city: this.projectCity,
				state: this.projectState,
				zip: this.projectZip
			} );
		}
	}

	resource() {
		return "sales/sales-leads";
	}
}
